import { DevHubTypography } from '@devxdiscover/devhub-ui/dist/components/custom/DevHubTypography';
import { devhubMakeStyles } from '@devxdiscover/devhub-ui/dist/style/devhubMakeStyles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';

interface MetricsModalHeadingProps {
  score: number;
}

/**
 * MetricModalHeading is a custom heading to be displayed in the Green Score Modal
 * @param props MetricModalHeadingProps contains the Green Score to display in this heading
 * @returns
 */
function MetricsModalHeading(props: MetricsModalHeadingProps) {
  const classes: ClassNameMap<string> = devhubMakeStyles({
    headingScore: {
      marginRight: '10px',
    },
    metricModalHeading: {
      display: 'flex',
      alignItems: 'center',
      color: '#3ea436',
    },
  })();
  return (
    <div className={classes.metricModalHeading}>
      <DevHubTypography
        // fontSize="extraLarge"
        variant="h3"
        weight="bold"
        className={classes.headingScore}
      >
        {props.score}
      </DevHubTypography>
      <DevHubTypography fontSize="large" className={classes.headingText}>
        DevHub Green Score
      </DevHubTypography>
    </div>
  );
}

export default MetricsModalHeading;
